import { render, staticRenderFns } from "./menu-category-list.vue?vue&type=template&id=e015cb42&scoped=true"
import script from "./menu-category-list.vue?vue&type=script&lang=js"
export * from "./menu-category-list.vue?vue&type=script&lang=js"
import style0 from "./menu-category-list.vue?vue&type=style&index=0&id=e015cb42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e015cb42",
  null
  
)

export default component.exports